import { render, staticRenderFns } from "./NewPopupInfo.vue?vue&type=template&id=777025f7"
import script from "./NewPopupInfo.vue?vue&type=script&lang=js"
export * from "./NewPopupInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports